var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.loading && !_vm.error)?_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}}):_vm._e(),(!_vm.loading && _vm.error)?_c('p',{staticClass:"error-message"},[_vm._v("\n    "+_vm._s(_vm.$t('signIn.external-login-generic-error'))+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }